import view from './view';

class AddRecipeView extends view {
  _parentElement = document.querySelector('.upload');
  _message = 'Recipe was successfully uploaded!';
  _window = document.querySelector('.add-recipe-window');
  _overlay = document.querySelector('.overlay');
  _btnOpen = document.querySelector('.nav__btn--add-recipe');
  _btnClose = document.querySelector('.btn--close-modal');

  constructor() {
    super();
    this._addHandlerShowWindow();
    this._addHandlerHideWindow();
  }

  toggleWindow() {
    this._overlay.classList.toggle('hidden');
    this._window.classList.toggle('hidden');
  }

  _addHandlerShowWindow() {
    this._btnOpen.addEventListener('click', () => {
      // Reset the form markup before showing the modal
      this._parentElement.innerHTML = this._generateMarkup();
      this.toggleWindow();
    });
  }

  _addHandlerHideWindow() {
    this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
    this._overlay.addEventListener('click', this.toggleWindow.bind(this));
  }

  _generateMarkup() {
    return `
      <div class="upload__form-fields">
        <p class="upload__small-text">
          Scroll within this area to fill the rest of the form
        </p>
        <div class="upload__column">
          <h3 class="upload__heading">Recipe data</h3>
          <label>Title</label>
          <input placeholder="Chilli con carne" required name="title" type="text" />
          <label>URL</label>
          <input placeholder="Link to instructions" required name="sourceUrl" type="text" />
          <label>Image URL</label>
          <input placeholder="https://example.com/image.jpg" required name="image" type="text" />
          <label>Publisher</label>
          <input placeholder="The Saucemaster" required name="publisher" type="text" />
          <label>Prep time</label>
          <input placeholder="120" required name="cookingTime" type="number" />
          <label>Servings</label>
          <input placeholder="4" required name="servings" type="number" />
        </div>

        <div class="upload__column">
          <h3 class="upload__heading">Ingredients</h3>
          <label>Ingredient 1</label>
          <input placeholder="0.5,kg,Rice" type="text" required name="ingredient-1" />
          <label>Ingredient 2</label>
          <input placeholder="1,,Avocado" type="text" name="ingredient-2" />
          <label>Ingredient 3</label>
          <input placeholder=",,salt" type="text" name="ingredient-3" />
          <label>Ingredient 4</label>
          <input type="text" name="ingredient-4" placeholder="Format: 'Quantity,Unit,Description'" />
          <label>Ingredient 5</label>
          <input type="text" name="ingredient-5" placeholder="Format: 'Quantity,Unit,Description'" />
          <label>Ingredient 6</label>
          <input type="text" name="ingredient-6" placeholder="Format: 'Quantity,Unit,Description'" />
        </div>
      </div>

      <button class="btn upload__btn">
        <svg>
          <use href="/icons.21bad73c.svg#icon-upload-cloud"></use>
        </svg>
        <span>Upload</span>
      </button>
    `;
  }

  addHandlerUpload(handler) {
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      const formDataArr = [...new FormData(this)];
      const formData = Object.fromEntries(formDataArr);
      handler(formData);
    });
  }
}

export default new AddRecipeView();
